import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import React from "react";
import BusinessIcon from "@mui/icons-material/Business";
import { useState } from "react";
import request from "../../Helpers/API";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { types } from "../../Helpers/Types";
import { GetKey } from "../../Helpers/GetKey";

export const ClientesDatosGeneralesVendedores = ({ disabled, setLoading }) => {
  const { idcliente } = useSelector((store) => store.clientes);
  const dispatch = useDispatch();
  const [vendedores, setVendedores] = useState([]);
  const [state, setState] = useState({
    razonsocial: "",
    rfc: "XAXX010101000",
    tipopersona: "",
    mediocontacto: "",
    tiempoagricultor: 0,
    regimenfiscal: "",
    idvendedor: "",
    nombre: "",
    nombre2: "",
    apellidopaterno: "",
    apellidomaterno: "",
    curp: "",
    sexo: "",
    estadocivil: "",
    regimenconyugal: "",
    referenciabancaria: "",
    edad: 0,
    fecha: new Date(),
  });

  useEffect(() => {
    // setLoading(true);
    if (disabled === false) {
      request
        .get("SolicitudCredito/Rol/usuario=0")
        .then((result) => {
          // setLoading(false);
          // Verifica si alguno de los objetos en el array tiene idrol igual a "CAPP"
          const hasCappRole = result.some((item) => item.idrol === "VEND");

          if (hasCappRole) {
            const idVendedor = result.find(
              (item) => item.idrol === "VEND"
            ).idusuario;
            setState({
              ...state,
              idvendedor: idVendedor,
            });
          }
        })
        .catch((error) => {
          // setLoading(false);
          Swal.fire("CLIENTES", JSON.stringify(error), "error");
        });
    }
  }, []);

  useEffect(() => {
    if (idcliente !== undefined && idcliente !== null && idcliente > 0) {
      setLoading(true);
      request
        .get(`Clientes/BuscarID?idcliente=${Number(idcliente)}`)
        .then((result) => {
          setLoading(false);
          setState({
            razonsocial: result.razon_social,
            rfc: result.rfc,
            tipopersona: result.tipo_persona,
            mediocontacto: result.medio_contacto,
            tiempoagricultor: result.tiempo_agricultor,
            regimenfiscal: result.regimen_fiscal,
            nombre: result.nombre,
            nombre2: result.nombre2,
            apellidopaterno: result.apellido_paterno,
            apellidomaterno: result.apellido_materno,
            curp: result.curp,
            sexo: result.sexo,
            estadocivil: result.estado_civil,
            regimenconyugal: result.regimen_conyugal,
            referenciabancaria: result.referencia,
            edad: result.edad,
            idvendedor: result.idvendedor,
          });
        })
        .catch(async (error) => {
          setLoading(false);
          await Swal.fire("Clientes", JSON.stringify(error), "success");
        });
    } else if (disabled === false) {
      setState({
        razonsocial: "",
        rfc: "XAXX010101000",
        tipopersona: "",
        mediocontacto: "",
        tiempoagricultor: 0,
        regimenfiscal: "",
        idvendedor: "",
        nombre: "",
        nombre2: "",
        apellidopaterno: "",
        apellidomaterno: "",
        curp: "",
        sexo: "",
        estadocivil: "",
        regimenconyugal: "",
        referenciabancaria: "",
        edad: 0,
      });
    } else {
      setState({
        razonsocial: "",
        rfc: "",
        tipopersona: "",
        mediocontacto: "",
        tiempoagricultor: 0,
        regimenfiscal: "",
        idvendedor: "",
        nombre: "",
        nombre2: "",
        apellidopaterno: "",
        apellidomaterno: "",
        curp: "",
        sexo: "",
        estadocivil: "",
        regimenconyugal: "",
        referenciabancaria: "",
        edad: 0,
      });
    }
  }, [idcliente]);
  useEffect(() => {
    setLoading(true);
    request
      .get("DDLVendedor/Listado")
      .then((result) => {
        setLoading(false);
        setVendedores(result);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire("CLIENTES", JSON.stringify(error), "error");
      });
  }, []);
  const onGuardar = () => {
    // var result = ClienteDatosGeneralesVendedoresValidate(state);
    var result = {
      razon_social: state.razonsocial,
      rfc: "XAXX010101000",
      tipo_persona: "M",
      medio_contacto: "LL",
      tiempo_agricultor: 1,
      regimen_fiscal: "626",
      referencia: "",
      agrupacion: "I",
      tipo_venta: "CR",
      idvendedor: GetKey(state.idvendedor),
      idcliente: idcliente,
    };
    if (result === undefined || result === null || result === false) return;

    setLoading(true);
    // result.idcliente = idcliente;

    if (
      result.razon_social === undefined ||
      result.razon_social === null ||
      result.razon_social === ""
    ) {
      Swal.fire("Clientes", "El campo Razón Social es Obligatorio", "warning");
      setLoading(false);
      return false;
    }

    if (
      result.idvendedor === undefined ||
      result.idvendedor === null ||
      result.idvendedor === ""
    ) {
      Swal.fire(
        "Clientes",
        "Seleccione un vendedor para el cliente",
        "warning"
      );
      setLoading(false);
      return false;
    }
    const endpoint =
      result.tipo_persona === "M"
        ? "Clientes/Persona_Moral_Vendedor"
        : "Clientes/Persona_Fisica";

    request
      .post(endpoint, result)
      .then(async () => {
        setLoading(false);
        await Swal.fire("Clientes", "Datos cargados con exito", "success");
        setState({
          razonsocial: "",
          rfc: "",
          tipopersona: "",
          mediocontacto: "",
          tiempoagricultor: 0,
          regimenfiscal: "",
          idvendedor: "",
          nombre: "",
          nombre2: "",
          apellidopaterno: "",
          apellidomaterno: "",
          curp: "",
          sexo: "",
          estadocivil: "",
          regimenconyugal: "",
          referenciabancaria: "",
          edad: 0,
        });
        dispatch({
          type: types.clientes,
          payload: {
            clienteinput: "",
            clienteselected: "",
            idcliente: 0,
            clientesArray: [],
            disabled: true,
          },
        });
      })
      .catch(async (error) => {
        setLoading(false);
        await Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  const onCalcularRFC = () => {
    if (
      state.razonsocial === undefined ||
      state.razonsocial === null ||
      state.razonsocial === ""
    ) {
      Swal.fire(
        "Clientes",
        "Favor de indicar la fecha de nacimiento (Persona Fisica) o la fecha de constitución de la empresa (Persona Moral)",
        "warning"
      );
      return;
    }
    if (
      state.fecha === undefined ||
      state.fecha === null ||
      state.fecha === ""
    ) {
      Swal.fire(
        "Clientes",
        "Favor de indicar la fecha de nacimiento (Persona Fisica) o la fecha de constitución de la empresa (Persona Moral)",
        "warning"
      );
      return;
    }
  };
  return (
    <div className="fuentes-roboto-fs12 ">
      <div className="container-clientes-datos-generales scroll-4">
        <div className="clientes-form-2-controls">
          <TextField
            disabled={disabled}
            fullWidth
            label="Razon Social"
            size="small"
            color="success"
            className="w-66"
            value={state.razonsocial}
            onChange={({ target }) =>
              setState({ ...state, razonsocial: target.value.toUpperCase() })
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              maxLength: 100,
            }}
          />
          <TextField
            disabled={true}
            label="RFC"
            size="small"
            color="success"
            className={Number(idcliente) === -110 ? "w-22" : "w-33"}
            value={state.rfc}
            onChange={({ target }) =>
              setState({
                ...state,
                rfc: target.value.toUpperCase(),
              })
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
            inputProps={{
              maxLength: 13,
            }}
          />
          {idcliente === "AAA" ||
            (Number(idcliente) === -110 && <button>Generar RFC</button>)}
        </div>
        <Autocomplete
          disabled={disabled}
          fullWidth
          size="small"
          id="vendedor"
          freeSolo
          className="w-66"
          value={state.idvendedor}
          onChange={({ target }) =>
            setState({ ...state, idvendedor: target.outerText })
          }
          options={vendedores.map(
            (option) => `${option.idvendedor} - ${option.vendedor}`
          )}
          renderInput={(params) => <TextField {...params} label="VENDEDOR" />}
          sx={{ mr: 1, mt: 2 }}
        />
        <div className="clientes-form-footer">
          {idcliente === null || idcliente === undefined || idcliente === "" ? (
            <div></div>
          ) : (
            <div
              onClick={() => onGuardar()}
              className="clientes-form-button-guardar"
            >
              GUARDAR
            </div>
          )}
        </div>
        <div className="modal-calcula-rfc">
          <div className="modal-calcula-rfc-container">
            <span className="close-modal-rfc">X</span>
            <header>Calcular RFC</header>
            <main>
              <TextField
                fullWidth
                label="Razon Social"
                size="small"
                color="success"
                className="w-66"
                value={state.razonsocial}
                onChange={({ target }) =>
                  setState({
                    ...state,
                    razonsocial: target.value.toUpperCase(),
                  })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 100,
                }}
              />
              <TextField
                fullWidth
                label="Fecha de nacimiento o creación de la empresa"
                size="small"
                color="success"
                type="date"
                className="w-66"
                value={state.fecha}
                onChange={({ target }) =>
                  setState({ ...state, fecha: target.value.toUpperCase() })
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  maxLength: 100,
                }}
                sx={{
                  mt: 2,
                }}
              />
              <button onClick={onCalcularRFC}>Calcular</button>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};
